<!--  -->
<template>
  <div>

    <el-form :model="uploadForm" ref="upload"  label-width="100px" label-position="left">
      <el-form-item prop="files" label="Rating Category">
        <el-input style="width:100;"  placeholder="" disabled v-model="factsInfo.name"></el-input>
      </el-form-item>
      <el-input style="width:100%" type="textarea" maxlength="1000" show-word-limit placeholder="请输入内容" :autosize="{ minRows: 4}" v-model="value"></el-input>

      <el-row type="flex" class="row-bg" justify="center" style="margin-top:15px;">
          <el-button type="primary"  @click="addFacts">保存</el-button>
          <el-button @click="closeFacts">取消</el-button>
      </el-row>
    </el-form>

  </div>
</template>

<script>
import ratingTask from "@/api/AAA/ratingTask.js";
import { fileService } from "@/api/common/file-utils"

export default {
  props:['factsInfo','factsType'],
  data () {
    return {
       uploadForm: {},
       value:"",
    };
  },

  components: {},
  created(){
       this.value=this.factsType === "supplier"?this.factsInfo.supplierFacts:this.factsInfo.cqsFacts;
  },
  computed: {},

  methods: {
    addFacts(){
      this.$emit('closeFacts',this.value)
    },
    closeFacts(){
      this.$emit('closeFacts')
    }
  }
}

</script>
<style  scoped>
</style>
